import React, { Component } from "react";
import { Link } from "react-router-dom";
import Countdown, { zeroPad } from "react-countdown";
import { connect } from "react-redux";
import { Alert, Button, Divider, Image, Typography } from "antd";
import { HiOutlineArrowSmallLeft } from "react-icons/hi2";
import * as actionAuth from "../../store/auth/action";
import signUpIcon from "../../assets/img/image-signup.png";
import styles from "./style.module.css";
import { removeStorageWhenLogout } from "../../config/helper";

class ResendEmailConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: localStorage.getItem("resendEmail"),
      disabled: false,
      alertState: {
        show: false,
        variant: "",
        message: "",
      },
    };
    this.authResendVerify = this.authResendVerify.bind(this);
  }

  componentDidMount() {
    if (this.state.email === null) {
      removeStorageWhenLogout();
      window.location.href = "/signin";
    }
  }

  authResendVerify = async () => {
    await this.props.authResendVerify(`?email=${this.state.email}`);

    this.setState({
      disabled: true,
      alertState: {
        show: true,
        variant: "success",
        message: `We have successfully sent a confirmation email to ${this.state.email}. Please check your inbox.`,
      }
    });
  };

  renderCountdown = ({ hours, minutes, seconds }) => (
    <span>
      {zeroPad(minutes)}:{zeroPad(seconds)}
    </span>
  );

  render() {
    return (
      <div className={styles.resend_email_page}>
        <div className={styles.auth_wrapper}>
          <Link to="/signin" className={styles.btn_back_login}>
            <HiOutlineArrowSmallLeft style={{ fontSize: 24 }} />
          </Link>
          <div className={styles.signup_success_wrapper}>
            <Image preview={false} src={signUpIcon} />
            <Typography.Title level={3}>Email Confirmation</Typography.Title>
            <Typography.Paragraph>
              We have sent email to{" "}
              <strong style={{ color: "#1890ff" }}>{this.state.email}</strong>{" "}
              to confirm your account. After receiving the email, please follow
              the link provided to complete your registration.
            </Typography.Paragraph>
            <Divider
              style={{ borderBlockStart: "1px solid rgba(255,255,255,0.3)" }}
            />
            <Typography.Text className={styles.auth_signup_account}>
              Didn't receive email?
              <Button
                type="primary"
                loading={this.props.loading}
                disabled={this.state.disabled}
                className={styles.btn_signup}
                onClick={this.authResendVerify}
              >
                {this.state.disabled ? (
                  <Countdown
                    date={Date.now() + 180000}
                    renderer={this.renderCountdown}
                    onComplete={() => this.setState({ disabled: false })}
                  />
                ) : (
                  <>Re-send Verification Email</>
                )}
              </Button>
            </Typography.Text>
            {this.state.alertState.show && (
              <Alert
                closable
                type={this.state.alertState.variant}
                message={this.state.alertState.message}
                style={{ marginTop: 10 }}
                onClose={() =>
                  this.setState({
                    alertState: { show: false, variant: "", message: "" },
                  })
                }
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const stateToProps = (state) => {
  const { auth } = state;
  return {
    loading: auth.loading,
    resendResponse: auth.resendResponse,
  };
};

const dispatchToProps = (dispatch) => ({
  authResendVerify: (params) => dispatch(actionAuth.authResendVerify(params)),
});

export default connect(stateToProps, dispatchToProps)(ResendEmailConfirm);
